class SolicitacaoMaterial {
  id: Number = 0;
  codigoFornecedorSap: Number = 0;
  idSkuSolicitado: Number = 0;
  idSkuProposto: Number = 0;
  dataPrevisaoNecessidade: Date = new Date();
  dataProposta: Date = new Date();
  justificativaSolicitacao: String = "";
  quantidadeSolicitada: Number = 0;
  unidadeMedidaSolicitada: String = "";
  quantidadeProposta: Number = 0;
  unidadeMedidaProposta: String = "";
  justificativaProposta: String = "";
  d_E_L_E_T_E: Boolean = false;
  criadoEm: Date = new Date();
  excluidoEm: Date = new Date();
  step: Number = 0;
  stepForward: Date = new Date();
  dataEntrega: Date = new Date();
  // idNotificacao: Number = 0;
  aprovadoParceiro: Boolean = false;
  aprovadoBRF: Boolean = false;
  integradoSAP: Boolean = false;
  entregue: Boolean = false;
  contrato: String = "";
  ordemVenda: String = "";
  centro: String = "";
  deposito: String = "";
  observacao: String = "";
  dataCarregamento: Date = new Date();
  skuPropostoDescricao: string = "";
  skuSolicitadoDescricao: string = "";
  centroDescricao: string = "";
  siglaSku: string = "";
}

export default SolicitacaoMaterial;
